import '../scripts/utils/css-helpers.js';
/* import '../scripts/utils/splits.js'; */
import '../scripts/utils/theme-functions.js';
import '../scripts/utils/lazy-images.js';
import '../scripts/utils/localization-manager.js';
import '../scripts/utils/cart-attributes.js';

import '../scripts/components';

import '../scripts/metrics';

import '../scripts/legacy/application.js';

document.dispatchEvent(new CustomEvent('theme:loaded'));
